import { TranslateDescription } from "../../../types/TranslateDescription";

export interface SurveyDto {
    id: string;
    text: TranslateDescription;
    lastQuestionAnsweredOrder: number;
    
    questions: SurveyQuestionDto[]
}

export interface SurveyQuestionDto {
    id: string 
    text: TranslateDescription 
    order: number
    code?: string

    isAnswerMandatory?: boolean

    answerType: AnswerTypeEnum 
    textDefaultValue?: string 
    numberDefaultValue?: number 
    minimumValue?: number 
    maximumValue?: number
    minimumNumberOfCharacters?: number 
    maximumNumberOfCharacters?: number 
    numberOfDecimals?: number 

    formula?: string 
    showFormulaInSurvey?: boolean 

    isMultiselector?: boolean

    response?: string

    answerOptions: SurveyQuestionAnswer[]
}

export interface SurveyQuestionAnswerResponseDto
{
    surveyQuestionId: string;
    surveyParticipantId: string;
    response?: string;
    isAnswerMandatory: boolean;
    isOptionQuestion: boolean;
    isMultiselector?: boolean;
}

export interface SurveyQuestionAnswer
{
    id: string;
    text: TranslateDescription;
    value: number;
    puntuation: number;
    order: number;
}

export interface SurveyFormulaQuestionResponseDto {
    questionId: string;
    responseValue: string;
}

export enum AnswerTypeEnum {
    NPS,
    Text,
    Number,
    Option,
    Formula
}